import type { InputHTMLAttributes } from 'react';
import styles from './DatePicker.module.css';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  value: string;
  onChange?: (value: string) => void;
  label?: string;
}

/**
 * Theme-aware date input.
 *
 * Wraps <input type="date"> with styling driven by CSS custom-property tokens
 * (--input-bg, --input-text, --input-border, --primary-*) so it matches every
 * colour theme.  The browser's calendar popup inherits the correct light/dark
 * mode automatically because useTheme sets `color-scheme` on <html> whenever
 * the active theme changes.
 */
export default function DatePicker({ value, onChange, label, id, className = '', ...rest }: Props) {
  const inputId = id ?? (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

  return (
    <div className={styles.wrapper}>
      {label && (
        <label className={styles.label} htmlFor={inputId}>
          {label}
        </label>
      )}
      <input
        {...rest}
        id={inputId}
        type="date"
        value={value}
        onChange={onChange ? (e) => onChange(e.target.value) : undefined}
        className={`${styles.input} ${className}`.trim()}
      />
    </div>
  );
}
